import React from 'react';

const LoadingPopup = ({ isLoading }) => {
  if (isLoading) {
    return (
      <div className="tvg-loading-popup">
        <p>
          <span className="fv-loading" />
          <span>Loading, please wait.</span>
        </p>
      </div>
    );
  }

  return <div />;
};

export default LoadingPopup;
